const initialState = {
  sendOTP: {},
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SEND_OPT':
      return {
        ...state,
        sendOTP: { ...action.payload },
      };
    default:
      return state;
  }
};
export default reducer;
